import { LocalDate } from '@js-joda/core';
import { localDate } from '../../serialization';
import { serializable } from 'serializr';
import { optional } from '../../validation';

export enum WeatherConditionType {
   UNKNOWN= 'UNKNOWN',
   CLEAR_SKY = 'CLEAR_SKY',
   FEW_CLOUDS = 'FEW_CLOUDS',
   SCATTERED_CLOUDS = 'SCATTERED_CLOUDS',
   BROKEN_CLOUDS = 'BROKEN_CLOUDS',
   SHOWER_RAIN = 'SHOWER_RAIN',
   RAIN = 'RAIN',
   FREEZING_RAIN = 'FREEZING_RAIN',
   HAIL = 'HAIL',
   THUNDERSTORM = 'THUNDERSTORM',
   SNOW = 'SNOW',
   WINDY = 'WINDY',
   MIST = 'MIST',
   SMOKE = 'SMOKE',
   TORNADO = 'TORNADO'
}

export enum WeatherUnit {
   F = 'F',
   C = 'C'
}

export class WeatherDay {

   @serializable(localDate())
   date: LocalDate;

   @serializable
   @optional
   minTemp?: number;

   @serializable
   @optional
   maxTemp?: number;

   @serializable
   @optional
   units?: WeatherUnit;

   @serializable
   @optional
   condition?: WeatherConditionType;
}
